import {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencil, faCheck} from "@fortawesome/free-solid-svg-icons";
import InputField from "./InputField";
import Button from "./Button";

function EditableField({
                           value,
                           suffix = "",
                           onSave,
                           type = 'text'
                       }) {
    const [isEditing, setIsEditing] = useState(false);
    const [inputValue, setInputValue] = useState(value);

    const handleSave = () => {
        onSave(inputValue);
        setIsEditing(false);
    };

    return (
        <div className="flex items-center gap-x-3">
            {isEditing ? (
                <>
                    <InputField
                        type={type}
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        className="w-24 rounded border px-2 py-1"
                    />

                    <span>{suffix}</span>

                    <Button onClick={handleSave}>
                        <FontAwesomeIcon icon={faCheck} size="lg"/>
                    </Button>
                </>
            ) : (
                <>
          <span>
            {value} {suffix}
          </span>

                    <Button onClick={() => setIsEditing(true)}>
                        <FontAwesomeIcon icon={faPencil} size="lg"/>
                    </Button>
                </>
            )}
        </div>
    );
}

export default EditableField;